import { useState, useContext } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Notyf } from "notyf";
import { Navigate } from "react-router-dom"; // Add this import
import UserContext from "../context/UserContext";

export default function EditProduct({ product, fetchData }) {
  const notyf = new Notyf();
  const { user } = useContext(UserContext);

  // input states
  const productId = product._id;

  const [name, setName] = useState(product.name);
  const [description, setDescription] = useState(product.description);
  const [price, setPrice] = useState(product.price);
  const [imageUrl, setImageUrl] = useState(product.imageUrl); // New state for image URL
  const [category, setCategory] = useState(product.category || ""); // Default to product's category
  const [isNew, setIsNew] = useState(product.isNew || false); // Default to product's isNew value
  const [recommended, setRecommended] = useState(product.recommended || false); // Default to product's recommended value
  const [showEdit, setShowEdit] = useState(false);

  const openEdit = () => {
    setShowEdit(true);
  };

  const closeEdit = () => {
    setShowEdit(false);
    setName("");
    setDescription("");
    setPrice(0);
    setImageUrl(""); // Clear image URL when closing modal
    setCategory(""); // Clear category
    setIsNew(false); // Reset isNew to false
    setRecommended(false); // Reset recommended to false
  };

  const editProduct = (e) => {
    e.preventDefault();

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/products/${productId}/update`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          name: name,
          description: description,
          price: price,
          imageUrl: imageUrl, // Include imageUrl in the request
          category: category, // Include category in the request
          isNew: isNew, // Include isNew in the request
          recommended: recommended, // Include recommended in the request
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          notyf.success("Product Updated Successfully");
          closeEdit();
          fetchData();
        } else {
          notyf.error("Something Went Wrong");
          closeEdit();
        }
      });
  };

  return user.isAdmin === true ? (
    <>
      <Button variant="primary" size="sm" onClick={openEdit}>
        Update
      </Button>

      {/* EDIT MODAL */}
      <Modal show={showEdit} onHide={closeEdit}>
        <Form onSubmit={editProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="productName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="productDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="productPrice">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="productImageUrl">
              <Form.Label>Image URL</Form.Label>
              <Form.Control
                type="text"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                required
              />
            </Form.Group>

            {/* Category Dropdown */}
            <Form.Group controlId="productCategory">
              <Form.Label>Category</Form.Label>
              <Form.Control
                as="select"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Select Category</option>
                <option value="Cakes & Cupcakes">Cakes & Cupcakes</option>
                <option value="Cookies & Bars">Cookies & Bars</option>
                <option value="Pies & Tarts">Pies & Tarts</option>
                <option value="Pastries & Croissants">
                  Pastries & Croissants
                </option>
                <option value="Cheesecakes">Cheesecakes</option>
                <option value="Vegan & Gluten-Free Desserts">
                  Vegan & Gluten-Free Desserts
                </option>
              </Form.Control>
            </Form.Group>

            {/* New Product Checkbox */}
            <Form.Group controlId="productIsNew">
              <Form.Check
                type="checkbox"
                label="Is New"
                checked={isNew}
                onChange={(e) => setIsNew(e.target.checked)}
              />
            </Form.Group>

            {/* Recommended Checkbox */}
            <Form.Group controlId="productRecommended">
              <Form.Check
                type="checkbox"
                label="Recommended"
                checked={recommended}
                onChange={(e) => setRecommended(e.target.checked)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeEdit}>
              Close
            </Button>
            <Button variant="success" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  ) : (
    <Navigate to="/products" />
  );
}
